/**
 * Quotation line items: at most one row per catalog `productId`.
 * Empty rows (productId === null) are ignored — multiple blank rows are fine.
 */
export function findDuplicateProductRowIndex(
  items: ReadonlyArray<{ productId: number | null }>,
  rowIndex: number,
  productId: number,
): number {
  return items.findIndex(
    (it, i) => i !== rowIndex && it.productId === productId,
  );
}
